import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const createNotification = async notificationData => {
  const url = `${baseUrl}/aws/notifications`
  console.log('New Notification Data: ', notificationData)
  const response = await axios.post(url, notificationData)
  return response.data // Assumes the response data includes the new lead with `id`
}

export const useCreateNotification = () => {
  const { showSnackbar } = useSnackbarContext()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: createNotification,
    onMutate: async newNotification => {
      await queryClient.cancelQueries({ queryKey: ['notifications'] })

      // Snapshot the previous value
      const previousNotifications = queryClient.getQueryData(['notifications'])

      // Do not optimistically update here because we don't have the new `id` yet
      return { previousNotifications }
    },
    onError: (err, newNotification, context) => {
      queryClient.setQueryData(['notifications'], context.previousNotifications)
      console.error('Mutation Error:', err)
      showSnackbar((err as any).response?.data?.message || err.message, 'error')
    },
    onSuccess: data => {
      queryClient.setQueryData(['notifications', data.userId], old => {
        if (!Array.isArray(old)) return [data]
        return [...old, data]
      })
      showSnackbar('Notification created', 'info')
    },

    onSettled: () => {
      // queryClient.invalidateQueries({ queryKey: ['notifications'] })
    },
  })

  return mutation
}
